var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('z-header'),_vm._m(0),_c('z-footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min_width"},[_c('div',{staticClass:"success_box"},[_c('img',{attrs:{"src":require("../../assets/ic_success.png")}}),_c('span',[_vm._v("支付成功")])])])
}]

export { render, staticRenderFns }